import { Checkbox, FormControl, FormControlLabel, Grid } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { GENERAL_ENQUETE_JSON_INPUT_TYPE, Question } from 'src/@types/generalEnquete';
import RHFTextField from 'src/components/react-hook-form/RHFTextField';
import { useValidator } from 'src/features/general/enquete-create/hooks/useValidator';
import NumberOfElementsValidationForm from './NumberOfElementsValidationForm';
import QuestionItemForm from './QuestionItemForm';
import RequiredValidationForm from './RequiredValidationForm';

type QuestionCheckboxFormProps = {
  methods: UseFormReturn;
  existingQuestion?: Question;
};

const QuestionCheckboxForm = ({ methods, existingQuestion }: QuestionCheckboxFormProps) => {
  const { t } = useTranslation();
  const { rulesCreateQuestionTitle } = useValidator(methods);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <RHFTextField
            margin="normal"
            name="textQuestion"
            control={methods.control}
            fullWidth
            rows={2}
            multiline
            placeholder={t('enqueteCreate.inputQuestion')}
            rules={rulesCreateQuestionTitle}
            defaultValue={existingQuestion ? existingQuestion.title : ''}
          />
        </Grid>
      </Grid>
      <QuestionItemForm methods={methods} existingQuestion={existingQuestion} inputType={GENERAL_ENQUETE_JSON_INPUT_TYPE.CHECKBOX}>
        <FormControl>
          <FormControlLabel control={<Checkbox />} disabled label="" />
        </FormControl>
      </QuestionItemForm>
      <RequiredValidationForm methods={methods} existingQuestion={existingQuestion} />
      <NumberOfElementsValidationForm methods={methods} existingQuestion={existingQuestion} />
    </>
  );
};

export default QuestionCheckboxForm;
